import {rpAppLink} from "@pg-mono/rp-routes";

import {IRcnAddressKey} from "../types/IRcnAddress";

export const getPricesAddressLink = ({city, street, number}: IRcnAddressKey): string => {
    const key = [city, street, number].map((part) => encodeURIComponent(part).replace(/-/g, "%2D")).join("-");
    return `${rpAppLink.prices.flats.base()}${key}/`;
};
import {rpAppLink} from "@pg-mono/rp-routes";

import {IRcnAddressKey} from "../types/IRcnAddress";

export const getPricesAddressLink = ({city, street, number}: IRcnAddressKey): string => {
    const key = [city, street, number].map((part) => encodeURIComponent(part).replace(/-/g, "%2D")).join("-");
    return `${rpAppLink.prices.flats.base()}${key}/`;
};
